<template>

  <div class="card-background">
      <div class="columns">

          <TournamentMenu :tournament="tournament" :event="event" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet">

        <div v-if="event" class="tournament-event-entries-container">
          <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ event.name }} - Entries</h2>

          <b-table :data="event.entries" v-if="event" @click="entryClick">
              <template slot-scope="props">
                  <b-table-column field="id" label="#">
                      {{ props.row.id }}
                  </b-table-column>

                  <b-table-column field="id" label="Entry">
                      <Entry :tournament="tournament" :event="event" :entry="props.row" :showMissing="true" />
                  </b-table-column>
              </template>
          </b-table>


          <div class="has-text-right" style="margin-top: 25px;">
            <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/draw/add'" class="button is-link is-medium">Add draw</router-link> &nbsp; &nbsp;
            <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/entry/add'" class="button is-danger is-medium">Add entry</router-link>
          </div>
        </div>

        <div v-if="!event">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import Entry from '../components/Entry.vue';
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
    return {
      tableColumns: [
        {field: 'id', label: '#'},
        {field: 'entry', label: 'Entry', class: 'preserve-newlines'}
      ]
    }
  },
  computed: {
      event: function() {
          let selected = null;
          if (this.tournament && this.tournament.events) {
              selected = this.tournament.events.filter(event => event.id == this.eventId);
              if (selected && selected.length > 0) {
                  selected = selected[0];
              } else {
                  selected = null;
              }
          }

          return selected;
      },
      eventId: function() { return this.$route.params.event; },

    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {
    entryClick(entry) {
      let tournamentId = this.$route.params.id;
      let eventId = this.$route.params.event;

      this.$router.push('/tournaments/' + tournamentId + '/events/' + eventId + '/entry/' + entry.id + '/edit');
    }
  },

  components: { TournamentMenu, Entry },
  name: 'tournament-event-entries'
}
</script>



<style>
  div.tournament-event-entries-container div.b-table tbody tr {
    cursor: pointer;
  }
</style>
